var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6569 2.07107C12.0474 1.68054 12.0474 1.04738 11.6569 0.656854C11.2663 0.26633 10.6332 0.26633 10.2426 0.656854L6 4.89949L1.75736 0.656854C1.36684 0.26633 0.73367 0.26633 0.343146 0.656854C-0.0473788 1.04738 -0.0473785 1.68054 0.343146 2.07107L4.58579 6.31371L0.343146 10.5563C-0.0473791 10.9469 -0.0473791 11.58 0.343146 11.9706C0.73367 12.3611 1.36683 12.3611 1.75736 11.9706L6 7.72792L10.2426 11.9706C10.6332 12.3611 11.2663 12.3611 11.6569 11.9706C12.0474 11.58 12.0474 10.9469 11.6569 10.5563L7.41421 6.31371L11.6569 2.07107Z",
    fill: "#6B7280",
    fillOpacity: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMatch);
export default __webpack_public_path__ + "static/media/close_match.c6e5adef315ed040ecb9da88541a0f5a.svg";
export { ForwardRef as ReactComponent };